import React, { useEffect, useState } from 'react';

const useClickedOutsideElement = <T extends HTMLElement>(
  ref: React.RefObject<T>,
) => {
  const [clickedOutside, setClickedOutside] = useState<boolean>(false);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current) {
        setClickedOutside(!ref.current.contains(event.target as HTMLElement));
      }
    };

    document.addEventListener('mousedown', handleClick);
    document.addEventListener('mouseup', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('mouseup', handleClick);
    };
  }, [ref]);

  return clickedOutside;
};

export default useClickedOutsideElement;
